export default __webpack_public_path__ + "static/figure-gallery-3-reference-a39020aea348a520357dcddd1a7f10c5.jpg";